import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import Select, {components, createFilter} from "react-select"
import sortBy from "lodash-es/sortBy";
import orderBy from "lodash-es/orderBy";
import debounce from 'lodash-es/debounce';
import groupBy from 'lodash-es/groupBy';
import AppText from "./AppText";
import {GlobalStyleAttributes} from "../../styles/GlobalStyles";
import {
    CATEGORY_SELECT,
    COACH_SELECT, ITEMS_SELECT,
    LEAD_SOURCE_SELECT,
    LEAD_STATUS_SELECT,
    LOST_REASONS_SELECT,
    MESSAGE_TEMPLATE_SELECT, SEASONS_SELECT,
    NOTE_TEMPLATE_SELECT,
    FORM_TYPE_SELECT,
    SPACE_SELECT,
    STAFF_SELECT,
    TASK_TYPES_SELECT,
    USERS_SELECT,
    restrictions, SCHEDULE_CANCEL_REASON_SELECT,
    BOX_CATEGORIES_GROUPS_SELECT
} from "../../services/ConstHelper";
import {Circle, Divider, HStack, VStack} from "native-base";
import {Colors} from "../../styles/Colors";
import {useDispatch, useSelector} from "react-redux";
import {isRTL, t} from "../../services/i18n";
import {
    CREATE_EVENT_MODAL,
    CREATE_EVENT_TYPE_MODAL,
    openModal,
    SETTINGS_VALUE_MODAL,
    updateModalRes,
    CREATE_GROUP_CATEGORY_MODAL
} from "../../redux/modalManagerSlice";
import {fetchApi} from "../../services/HTTP";
import AsyncSelect from "react-select/async";
import {
    checkRestrictions,
    isMobile,
    sendDataEvent,
    handlePricingWithCurrency,
    getBoxSettingProperties
} from "../../services/Helpers";
import UserAvatar from "./UserAvatar";
import {flowOptions} from '../Structure/Schedule/Popups/CreateEvent/FlowOptions';
import usePermissions from '../../services/Permissions';
import {openStepperModal} from '../../services/stepperService';
import {
    CANCEL_REASONS,
    LEAD_SOURCE_TYPE,
    LEAD_STATUS_TYPE,
    LOST_REASONS_TYPE,
    SEASONS,
    FORM_TYPE
} from '../../Configs/SettingsValueModalOptions';
import useCheckPermission from "../../Hooks/useCheckPermission";
import {BoxCategoryTypes, Roles, StaffMemberRoles} from "../../Configs/DatabaseConsts";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {light} from '@fortawesome/fontawesome-svg-core/import.macro';
import {GlobalConsts} from '../../styles/GlobalConsts';
import CustomButtonV2 from "./CustomButtonV2";
import { Flex } from 'antd';
import {lostLeadStatusId} from '../../services/ConstHelper';

const AdvanceSelect = (props) => {
    const { options, initValue, initOption, onChange, type, isSearchable = true, hideCreateBtn, dontSort, customStyle, allowInactive, categoryTypeId, hideLeadType, onlyLeadType, hideFreefitType, hideArchived, hideCustomerId, target, hideGroupDependents, showGroupStatus, placeholder, fontSize, asyncInit, isError, showInApp, withGroups, getInactiveMemberships, uuid, showSelectedUserWithStatus, smallSelectionDesign, selectedOptionColor, testID, ...rest } = props;
    const createEventTypeModalRes = useSelector(state => state.modalManager.createEventTypeModal.processRes)
    const createEventModalRes = useSelector(state => state.modalManager.createEventModal.processRes)
    const settingsModalRes = useSelector(state => state.modalManager.settingsValueModal.processRes)
    const createGroupCategoryModalRes = useSelector(state => state.modalManager.createGroupCategoryModal.processRes)
    const selectedLocation = useSelector(state => state.userSettings.scheduleLocation)
    const categoryTypes = useSelector((state) => state.schedule.categoryTypes);
    const user = useSelector(state => state.user.user)
    const [value, setValue] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [optionsSorted, setOptionsSorted] = useState(null);
    const isAsync = useMemo(() => (!options && (type === USERS_SELECT)), [options, type]);
    const currencySymbol = useMemo(() => selectedLocation ? selectedLocation.currency_symbol : '',[selectedLocation])
    const dispatch = useDispatch()
    const selectRef = useRef()
    const {has} = usePermissions()
    const {hasBookingServicesPermission} = useCheckPermission();
    const isBookingType = Object.values(BoxCategoryTypes).includes(categoryTypeId);

    useEffect(() => {
        const hasInitOption = initOption !== null && initOption !== undefined;
        const initComparable = hasInitOption ? initOption?.value : initValue;
        if ((hasInitOption || (initValue !== null && initValue !== undefined)) && (initComparable !== value?.value)) {
            let valueObject;
            if (hasInitOption) {
                valueObject = initOption;
            } else if (isAsync) {
                if (asyncInit) {
                    valueObject = initValue
                } else {
                    valueObject = optionsSorted?.reduce((acc, type) => [...acc, ...type.options], []).find(item => item.value === initValue)
                }
            } else if (rest.isMulti) {
                valueObject = options?.filter(item => initValue.find(iv => iv.value === item.value));
            } else {
                valueObject = options?.find(item => item.value === initValue);
            }
            setValue(valueObject)
        }
        if (!hasInitOption && initValue === null) setValue(null);
    }, [initValue, initOption, options, optionsSorted])

    useEffect(() => {
        getTypeOptionComponent()
    }, [type]);

    useEffect(() => {
        if(options) setOptionsSorted(dontSort ? options : sortOptions(options))
    }, [options]);

    useEffect(() => {
        if(createEventTypeModalRes && type === CATEGORY_SELECT) {
            onChange(createEventTypeModalRes)
            dispatch(updateModalRes({modalName: CREATE_EVENT_TYPE_MODAL, res: null}))
        }
    }, [createEventTypeModalRes]);

    useEffect(() => {
        if(settingsModalRes) {
            if([SEASONS_SELECT, SCHEDULE_CANCEL_REASON_SELECT, FORM_TYPE_SELECT].includes(type)) {
                onChange(settingsModalRes)
                dispatch(updateModalRes({modalName: SETTINGS_VALUE_MODAL, res: null}))
            }
        }
    }, [settingsModalRes]);

    useEffect(() => {
        if(createEventModalRes && type === STAFF_SELECT && createEventModalRes?.flowName === flowOptions.STAFF_MEMBER) {
            onChange({...createEventModalRes, value: createEventModalRes.id, label: `${createEventModalRes.first_name} ${createEventModalRes.last_name || ''}`})
            dispatch(updateModalRes({modalName: CREATE_EVENT_MODAL, res: null}))
        }
        if(createEventModalRes && type === COACH_SELECT && createEventModalRes?.flowName === flowOptions.STAFF_MEMBER) {
            onChange({...createEventModalRes, value: createEventModalRes.user_fk, label: `${createEventModalRes.first_name} ${createEventModalRes.last_name || ''}`})
            dispatch(updateModalRes({modalName: CREATE_EVENT_MODAL, res: null}))
        }
        if(createEventModalRes && type === SPACE_SELECT && createEventModalRes?.flowName === flowOptions.SPACE_FLOW) {
            if(!uuid || (uuid === createEventModalRes.uuid)) {
                onChange({...createEventModalRes, value: createEventModalRes.id, label: createEventModalRes.name})
                dispatch(updateModalRes({modalName: CREATE_EVENT_MODAL, res: null}))
            }
        }
        if(createEventModalRes && type === TASK_TYPES_SELECT && createEventModalRes.flowName === flowOptions.TASK_TYPE_FLOW) {
            onChange({...createEventModalRes, value: createEventModalRes.id, label: createEventModalRes.type})
            dispatch(updateModalRes({modalName: CREATE_EVENT_MODAL, res: null}))
        }
        if(createEventModalRes && type === NOTE_TEMPLATE_SELECT && createEventModalRes.flowName === flowOptions.NOTE_TEMPLATE) {
            onChange({...createEventModalRes, value: createEventModalRes.id, label: createEventModalRes.name})
            dispatch(updateModalRes({modalName: CREATE_EVENT_MODAL, res: null}))
        }
    }, [createEventModalRes]);

    useEffect(() => {
        if (createGroupCategoryModalRes && type === BOX_CATEGORIES_GROUPS_SELECT) {
            onChange(createGroupCategoryModalRes)
            dispatch(updateModalRes({modalName: CREATE_GROUP_CATEGORY_MODAL, res: null}))
        }
    }, [createGroupCategoryModalRes]);


    const getTypeOptionComponent = (args) => {
        if(args) {
            switch(type) {
                case CATEGORY_SELECT:
                    return getCategoryOptionStyle(args)
                case USERS_SELECT:
                case COACH_SELECT:
                case STAFF_SELECT:
                    return getUsersOptionStyle(args)
                case MESSAGE_TEMPLATE_SELECT:
                    return getMessageTemplateOptionStyle(args)
                case TASK_TYPES_SELECT:
                    return has('viewTasksV5') ? getTaskTypeOptionStyle(args) :
                        <AppText fontSize={fontSize ? fontSize : GlobalStyleAttributes.fonts.standard16}>{args?.label}</AppText>
                case NOTE_TEMPLATE_SELECT:
                    return <AppText fontSize={fontSize ? fontSize : GlobalStyleAttributes.fonts.standard16}>{args?.label}</AppText>
                default:
                    return <AppText fontSize={fontSize ? fontSize : GlobalStyleAttributes.fonts.standard16}>{args?.label}</AppText>
            }
        }
    }

    const getCategoryOptionStyle = ({label, membership_types, category_color}) => {
        return (
            <HStack alignItems={'center'} space={'0.5rem'}>
                <HStack space={'0.5rem'} alignItems={'center'}>
                    <Circle bg={category_color} size={'20px'}/>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
                </HStack>
                {
                    membership_types && membership_types.length > 0 &&
                    <HStack space={'0.5rem'} alignItems={'center'}>
                        <Divider orientation="vertical" bg={Colors.newDesign.darkGrey} thickness="1" h={"15px"}/>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>{handlePricingWithCurrency(membership_types[0]?.price?.toLocaleString(), currencySymbol)}</AppText>
                    </HStack>
                }
            </HStack>
        )
    }

    const getTaskTypeOptionStyle = ({label, task_type_color}) => {
        return (
            <HStack space={'0.5rem'} alignItems={'center'}>
                <Circle bg={task_type_color || '#D0FFF9'} size={'20px'}/>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
            </HStack>
        )
    }

    const getUsersOptionStyle = ({label, cloudinary_image, first_name, last_name, user_fk}) => {
        label = label ? label.replace('null', '') : label
        return (
            <HStack alignItems={'center'} space={'0.5rem'} overflowX={'hidden'}>
                <UserAvatar imageUri={cloudinary_image} size={25} firstName={first_name} lastName={last_name}/>
                <HStack space={'0.5rem'}>
                    <AppText fontSize={fontSize ? fontSize : GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
                    <AppText fontSize={fontSize ? fontSize : GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>{user_fk === user.user_fk ? `(${t('assign-to-me')})` : ''}</AppText>
                </HStack>
            </HStack>
        )
    }

    const renderUserStatusBadge = (userType, isActive, statusFk) => {
        if (userType !== "lead" && isActive !== undefined) {
            return (
                <AppText
                    fontSize={'14px'}
                    style={{
                        backgroundColor: isActive ? '#E6FAEA' : '#FFF3F3',
                        color: isActive ? '#0D7F56' : '#EA3635',
                        borderRadius: 5,
                        borderWidth: 1,
                        borderColor: '#FFFFFF',
                        paddingVertical: 2,
                        paddingHorizontal: 6,
                        textAlign: 'center'
                    }}
                >
                    {isActive ? t('active') : t('inactive')}
                </AppText>
            )
        }
        if (userType === "lead" && statusFk === lostLeadStatusId) {
            return (
                <AppText
                    fontSize={'14px'}
                    style={{
                        backgroundColor: '#F9F9F9',
                        color: '#9D9D9D',
                        borderRadius: 5,
                        borderWidth: 1,
                        borderColor: '#FFFFFF',
                        paddingVertical: 2,
                        paddingHorizontal: 6,
                        textAlign: 'center'
                    }}
                >
                    {t('lostLeadStatus')}
                </AppText>
            )
        }
        return null
    }

    const getUserOptionComponent = ({label, cloudinary_image, first_name, last_name, user_fk, rivhit_customer_id, active, type, status_fk, groups_id, group_head, isMenu}) => {
        label = label ? label.replace('null', '') : label

        if (!isMenu && showSelectedUserWithStatus) {
            return (
                <HStack alignItems={'center'} space={'0.5rem'} justifyContent={'space-between'} w={'100%'} overflow={'hidden'}>
                    <HStack alignItems={'center'} space={'0.5rem'} flex={1} overflow={'hidden'}>
                        <UserAvatar imageUri={cloudinary_image} firstName={first_name} lastName={last_name} userType={type} size={25}/>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: '25px'}}>{label}</AppText>
                    </HStack>
                    {renderUserStatusBadge(type, active, status_fk)}
                </HStack>
            )
        }

        if (!isMenu && smallSelectionDesign) {
            return <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
        }

        return (
            <HStack my={'0.3rem'} justifyContent={'space-between'} alignItems={'center'}>
                <HStack alignItems={'center'} space={'0.5rem'}>
                    <UserAvatar imageUri={cloudinary_image} firstName={first_name} lastName={last_name} userType={type}/>
                    <VStack>
                        <HStack space={'0.5rem'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>{user_fk === user.user_fk ? `(${t('assign-to-me')})` : ''}</AppText>
                            {showGroupStatus && (
                                <AppText style={{ marginInlineStart: 10 }} color={'#9D9D9D'} fontSize={GlobalStyleAttributes.fonts.standard16}>
                                    {`(${t(groups_id ? 'head-of-group' : 'not-part-of-group')})`}
                                </AppText>
                            )}
                        </HStack>
                        {rivhit_customer_id && !hideCustomerId && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{t('customerId')}: {rivhit_customer_id}</AppText>}
                    </VStack>
                </HStack>
                {renderUserStatusBadge(type, active, status_fk)}
            </HStack>
        )
    }

    const getMessageTemplateOptionStyle = ({label, digital_form_id, scope}) => {
        return <Flex gap={'0.3rem'} align='center'>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
                {digital_form_id &&<FontAwesomeIcon icon={light('file')} fontSize={GlobalConsts.iconSize.XS} />}
                {scope === 'face_detect_link' && <FontAwesomeIcon icon={light('camera')} fontSize={GlobalConsts.iconSize.XS} />}
        </Flex>
    }

    const getItemOptionComponent = ({label, cloudinary_image, first_name, last_name, user_fk, rivhit_customer_id, active, type}) => {
        label = label ? label.replace('null', '') : label
        return (
            <HStack my={'0.5rem'} alignItems={'center'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{label}</AppText>
            </HStack>
        )
    }

    const getOptionComponent = (data, {context}) => {
        switch (type) {
            case USERS_SELECT:
                return getUserOptionComponent({...data, isMenu: context === 'menu'})
            case ITEMS_SELECT:
                return getItemOptionComponent(data)

        }
    }

    const ClearIndicator = props => {
        return (
            <components.ClearIndicator {...props}>
                <CustomButtonV2 type={'link'}
                                iconName={'fa-xmark'}
                                id={'select-clear-button'}
                                tooltipText={t('clear')}
                />
            </components.ClearIndicator>
        );
    };


      const MultiValueRemove = props => {
        return (
          <components.MultiValueRemove {...props}>
            <FontAwesomeIcon icon={light('x')} color={Colors.newDesign.darkGrey} fontSize={GlobalConsts.iconSize.XXS}/>
          </components.MultiValueRemove>
        );
      };

    const onBtnClick = () => {
        setIsMenuOpen(false)
        selectRef.current?.blur()
        switch(type) {
            case CATEGORY_SELECT:
                sendDataEvent('click create another service type');
                const type = categoryTypes.find(type => type.id === categoryTypeId ?? options[0].type)
                dispatch(openModal({ modalName: CREATE_EVENT_TYPE_MODAL, props: { target: null, type: type.name }}))
                break;
            case COACH_SELECT:
                sendDataEvent('click create another staff member');
                checkRestrictions(restrictions.ADD_STAFF_MEMBER, null, false, dispatch, () => {
                    openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL, props: {initSelection: flowOptions.STAFF_MEMBER, target, initProps: {roles: [StaffMemberRoles.COACH]}}})
                }, () => {})
                break;
            case STAFF_SELECT:
                sendDataEvent('click create another staff member');
                checkRestrictions(restrictions.ADD_STAFF_MEMBER, null, false, dispatch, () => {
                    openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL, props: {initSelection: flowOptions.STAFF_MEMBER, target}})
                }, () => {})
                break;
            case LEAD_STATUS_SELECT:
                dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: LEAD_STATUS_TYPE, onChange}}))
                break;
            case LEAD_SOURCE_SELECT:
                dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: LEAD_SOURCE_TYPE, onChange}}))
                break;
            case SPACE_SELECT:
                sendDataEvent('click create another space');
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL, props: {initSelection: flowOptions.SPACE_FLOW, uuid }})
                break;
            case TASK_TYPES_SELECT:
                openStepperModal({
                    dispatch, modalName: CREATE_EVENT_MODAL,
                    props: {initSelection: flowOptions.TASK_TYPE_FLOW, target: null},
                })
                break;
            case  LOST_REASONS_SELECT:
                dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: LOST_REASONS_TYPE, onChange}}))
                break;
            case SEASONS_SELECT:
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL, props: {type: SEASONS, initialValue: {} }}))
                break;
            case SCHEDULE_CANCEL_REASON_SELECT:
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: CANCEL_REASONS, initialValue: {val: null, default: false, scope: 'schedule'}, params: {} }}))
                break;
            case NOTE_TEMPLATE_SELECT:
                openStepperModal({
                    dispatch, modalName: CREATE_EVENT_MODAL,
                    props: {initSelection: flowOptions.NOTE_TEMPLATE, target: null},
                })
                break;
            case FORM_TYPE_SELECT:
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL, props: {type: FORM_TYPE}}))
                break;
            case BOX_CATEGORIES_GROUPS_SELECT:
                dispatch(openModal({
                  modalName: CREATE_GROUP_CATEGORY_MODAL,
                  props: {
                    target: null,
                    hideServiceTypeAssignment: true,
                  }
                }))
                break;
            // case CUSTOM_FIELD_SELECT:
            //     sendDataEvent('click create another custom field');
            //     dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.CUSTOM_FIELD, target: target}}))
            //     break;
        }
    }

    const fetchUsersFromInput = (input, callback) => { // dont touch this! this is the only way asyncSelect agreed to work!!!!
        if (input.length > 1) {
            fetchUsers(input).then((res) => callback(res))
        }
    }

    const fetchUsers = async (input) => {
        setIsLoading(true);
        const results = await fetchApi('usersBoxes/searchForMember', 'post', { input: input.replace("'", "׳"), withGroups, getInactiveMemberships }, false, true);
        if (results) {
            let filteredResults = results.filter(item => {
                return  item.first_name && (item.first_name.trim() !== "") &&
                        item.type !== Roles.UNION.toLowerCase() &&
                        (allowInactive || item.type === Roles.LEAD.toLowerCase() ? true : item.active) &&
                        (onlyLeadType ? item.type === Roles.LEAD.toLowerCase() : true) &&
                        (hideLeadType ? item.type !== Roles.LEAD.toLowerCase() : true) &&
                        (hideFreefitType ? item.type !== Roles.AGGREGATOR.toLowerCase() : true) &&
                        (hideArchived ? !item.deleted_at : true) &&
                        (hideGroupDependents ? !(item.groups_id && Number(item.group_head) !== 1) : true)
            }).reduce((acc, item) => [...acc, {...item, label: item.full_name, value: item.user_fk}],[]);

            filteredResults = sortOptions(filteredResults)
            filteredResults = groupUsers(filteredResults)
            setOptionsSorted(filteredResults)
            setIsLoading(false);
            return filteredResults
        }
        setIsLoading(false);
        return []
    }

    const asyncFetchUsers = useCallback(debounce(fetchUsersFromInput, 300),[hideLeadType, onlyLeadType, hideFreefitType, hideGroupDependents])



    const fetchFunction = (type) => {
        switch (type) {
            case USERS_SELECT:
                return asyncFetchUsers
        }
    }

    const sortOptions = (options) => {
        const ordered = orderBy(options, ['active', item => item?.label?.toLowerCase()], ['desc', 'asc'])
        return sortBy(ordered, [
            item => item?.user_fk === user.user_fk ? 0 : 1,
            item => item?.status_fk === 1027 ? 1 : 0
        ]);
    }

    const groupUsers = (options) => {
        let group = groupBy(options, 'type')
        const res = Object.keys(group).reduce((acc, groupKey) => ({...acc, [groupKey]: {...acc[groupKey], options: group[groupKey]}}),
            {
                'user': {
                    label: t('members'),
                    options: []
                },
                'aggregator': {
                    label: t('freefit'),
                    options: []
                },
                'union': {
                    label: t('unions'),
                    options: []
                },
                'lead': {
                    label: t('leads'),
                    options: []
                },
                'coach': {
                    label: t('staff'),
                    options: []
                }
            })
        return Object.values(res);
    }

    const closeMenu = () => {
        setTimeout(() => setIsMenuOpen(false), isMobile ? 500 : 0)
    }

    return (
        <>
            {isAsync ?
                <AsyncSelect isLoading={isLoading}
                             value={value}
                             loadOptions={fetchFunction(type)}
                             onChange={onChange}
                             isSearchable={isSearchable}
                             openMenuOnClick={false}
                             defaultOptions={value ? [{label: value.type, options: [value]}] : null}
                             defaultValue={value}
                             formatOptionLabel={getOptionComponent}
                             isRtl={isRTL()}
                             menuShouldScrollIntoView={false}
                             styles={{
                                 control: (baseStyles, state) => ({...baseStyles, fontFamily: 'Ploni', cursor: 'pointer', borderRadius: 4,
                                    ...(showSelectedUserWithStatus ? { minHeight: 38, height: 38, padding: 0, alignItems: 'center' } : {}),
                                    borderColor: isError ? Colors.newDesign.attendanceAbsentText : state.isFocused ? Colors.newDesign.mainBlue : Colors.borderColor,
                                    boxShadow: 'none',
                                    "&:hover": {
                                        borderColor: isError ? Colors.newDesign.attendanceAbsentText : Colors.newDesign.mainBlue
                                    },
                                }),
                                 ...(showSelectedUserWithStatus ? {
                                     valueContainer: (base) => ({ ...base, paddingTop: 0, paddingBottom: 0, paddingLeft: 8, paddingRight: 8, height: '100%', alignItems: 'center', flexWrap: 'nowrap' }),
                                     singleValue: (base) => ({ ...base, margin: 0, maxWidth: '100%', display: 'flex', alignItems: 'center' }),
                                     input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                     indicatorsContainer: (base) => ({ ...base, height: '100%', alignItems: 'center' }),
                                 } : {}),
                                 option: (baseStyles, state) => ({
                                     ...baseStyles,
                                     backgroundColor: state.isSelected ? (selectedOptionColor || Colors.borderColor) : state.isFocused ? Colors.newDesign.menuBar : Colors.newDesign.white,
                                     borderBottom: `1px ${Colors.borderColor} solid`,
                                     direction: isRTL() ? 'rtl' : 'ltr'
                                 }),
                                 menuPortal: base => ({...base, zIndex: 9999, fontFamily: 'Ploni'}),
                                 group: base => ({...base, padding: 0}),
                                 groupHeading: base => ({
                                     ...base,
                                     margin: 0,
                                     padding: "5px 10px",
                                     fontSize: GlobalStyleAttributes.fonts.infoText,
                                     backgroundColor: Colors.newDesign.greyBg,
                                     textTransform: "capitalize",
                                     color: Colors.newDesign.mainText
                                 }),
                             }}
                             menuPortalTarget={document.body}
                             placeholder={placeholder || t('search-user')}
                             components={{ DropdownIndicator: null, IndicatorSeparator: null, ClearIndicator }}
                             {...rest}
                />
                :
                <Select options={optionsSorted}
                        value={value}
                        onChange={onChange}
                        onMenuOpen={() => setIsMenuOpen(true)}
                        onMenuClose={closeMenu}
                        components={{Menu: (props) => <Menu type={type} onBtnClick={onBtnClick} hideCreateBtn={hideCreateBtn || (isBookingType && !hasBookingServicesPermission)} {...props}/>, ClearIndicator, IndicatorSeparator: null, MultiValueRemove}}
                        isSearchable={isSearchable}
                        formatOptionLabel={getTypeOptionComponent}
                        menuIsOpen={isMenuOpen}
                        ref={selectRef}
                        placeholder={placeholder || t('choose')}
                        filterOption={createFilter({matchFrom: 'any'})}
                        menuShouldScrollIntoView={false}
                        styles={{
                            container: base => ({
                                ...base,
                                ...customStyle
                            }),
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                fontFamily: 'Ploni',
                                fontSize,
                                backgroundColor: Colors.newDesign.white,
                                opacity: state.isDisabled ? 0.5 : 1,
                                cursor: 'pointer',
                                borderRadius: 4,
                                borderColor: isError ? Colors.newDesign.attendanceAbsentText : state.isFocused ? Colors.newDesign.mainBlue : Colors.borderColor,
                                boxShadow: 'none',
                                "&:hover": {
                                    borderColor: isError ? Colors.newDesign.attendanceAbsentText : Colors.newDesign.mainBlue
                                },
                            }),
                            option: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: (state.isSelected && !state.isDisabled) ? (selectedOptionColor || Colors.borderColor) : state.isFocused ? Colors.newDesign.menuBar : Colors.newDesign.white,
                                opacity: state.isDisabled ? 0.5 : 1,
                                direction: isRTL() ? 'rtl' : 'ltr',
                                "&:active": {
                                    backgroundColor: state.isDisabled
                                        ? Colors.newDesign.white  // Don't change if disabled
                                        : Colors.newDesign.menuBar  // Your desired active color
                                }
                            }),
                            menuPortal: base => ({...base, zIndex: 9999, fontFamily: 'Ploni'}),
                            group: base => ({...base, padding: 0}),
                            groupHeading: base => ({
                                ...base,
                                margin: 0,
                                padding: "5px 10px",
                                fontSize: GlobalStyleAttributes.fonts.infoText,
                                textTransform: "capitalize",
                                color: Colors.newDesign.mainText,
                                fontFamily: 'PloniSemiBold'
                            }),
                            multiValue: (baseStyles) => ({
                                ...baseStyles,
                                paddingInlineStart: '0.3rem',
                                backgroundColor: Colors.newDesign.menuBar,
                                "&:hover": {
                                    backgroundColor: Colors.newDesign.greyBg
                                },
                            }),
                            multiValueRemove: (baseStyles) => ({
                                ...baseStyles,
                                marginInlineEnd: '0.3rem',
                                backgroundColor: 'transparent',
                                "&:hover": {
                                    backgroundColor: 'transparent'
                                },
                            }),
                            menuList: base => ({ ...base, maxHeight: 240 }),
                        }}
                        menuPortalTarget={document.body}
                        isRtl={isRTL()}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        {...rest}
                />
            }
        </>
    );
};

export default AdvanceSelect;

const Menu = (props) => {
    const { type, onBtnClick, children, hideCreateBtn, ...rest} = props;
    const [btnText, setBtnText] = useState(null);
    const { has } = usePermissions()
    useEffect(() => {
        getBtnText()
    }, [type]);

    const getBtnText = () => {
        let text = null;
        switch(type) {
            case CATEGORY_SELECT:
                text = t('createAnother')
                break;
            case COACH_SELECT:
            case STAFF_SELECT:
                text = has('addCoach') ? t('createAnother') : null
                break;
            case LEAD_SOURCE_SELECT:
                text = has('boxSourceActions') ? t('createAnother') : null
                break;
            case LEAD_STATUS_SELECT:
                text = has('boxStatusActions') ? t('createAnother') : null
                break;
            case LOST_REASONS_SELECT:
                text = has('boxStatusActions') ? t('createAnother') : null
                break;
            case TASK_TYPES_SELECT:
                text = has('taskTypeActions') ? t('createAnother') : null
                break;
            case SPACE_SELECT:
                text = has('createSpace') ? t('createAnother') : null
                break;
            case SEASONS_SELECT:
                text = has('seasons') ? t('createAnother') : null
                break;
            case SCHEDULE_CANCEL_REASON_SELECT:
                text = has('scheduleCancelReason') ? t('createAnother') : null
                break;
            case NOTE_TEMPLATE_SELECT:
                text = has('userNoteTemplateActions') ? t('createAnother') : null
                break;
            case FORM_TYPE_SELECT:
                text = has('viewSettings') ? t('createAnother') : null
                break;
            case BOX_CATEGORIES_GROUPS_SELECT:
                text = has('boxCategoriesGroups') ? t('settingsAddBtn') : null
                break;
            // case CUSTOM_FIELD_SELECT:
            //     text = has('addCustomField') || true ? t('createAnother') : null
            //     break;
        }
        setBtnText(text)
    }

    return (
        <components.Menu {...rest}>
            {children}
            { btnText && !hideCreateBtn &&
                <CustomButtonV2 onClick={onBtnClick}
                                override={() =>
                                    <VStack space={'1rem'} p={'1rem'} w={'100%'}>
                                        <Divider orientation="horizontal" bg={Colors.borderColor} thickness="1" w={'100%'}/>
                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.mainBlue} style={{writingDirection: isRTL() ? 'rtl' : 'ltr'}}>+ {btnText}</AppText>
                                    </VStack>}
                />
            }
        </components.Menu>
    );
};
